if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest(`[data-section-type]`);
      this.variantLabels = this.querySelectorAll('.js-variant-label');
      if (!this.container || this.variantLabels.length === 0) {
        return;
      }
      this.container.addEventListener('theme:variant:change', this.handleVariantChange.bind(this));
    }

    /**
     * Sets the visible variant variantLabels.
     * @param {string} variantId - The variant id
     */
    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((variantLabel) => {
        variantLabel.classList.toggle("hidden", variantLabel.dataset.variantId.toString() !== variantId.toString());
      });
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      if (evt.detail.variant) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
